import React, { useState, useEffect } from "react";
import logo from "../../resource/7.png";
import Swal from "sweetalert2";
import axios from "axios";
import apiClient from "@/api/client";

const FiveYearRequest = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    date_of_birth: "",
    gender: "",
    street_address_line_1: "",
    street_address_line_2: "",
    city: "",
    postal_code: "",
    country: "",
    mobile_number: "",
    wt_number: "",
    email: "",
    "5_land_plots": false,
    "10_land_plots": false,
    "20_land_plots": false,
    "50_land_plots": false,
    query: "",
    ip_address: "",
  });

  const [loading, setLoading] = useState(false); // Loading state
  const [errors, setErrors] = useState({}); // Error state

  // Fetch IP address on component mount
  useEffect(() => {
    const fetchIP = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setFormData((prevFormData) => ({
          ...prevFormData,
          ip_address: response.data.ip, // Set the IP address
        }));
      } catch (error) {
        console.error("Error fetching IP address:", error);
      }
    };

    fetchIP();
  }, []);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox" || type === "radio") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: type === "checkbox" ? checked : value,
      }));
    } else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  // Validate form fields
  const validateForm = () => {
    const newErrors = {};

    // Validate First Name
    if (!formData.first_name) newErrors.first_name = "First Name is required";

    // Validate Last Name
    if (!formData.last_name) newErrors.last_name = "Last Name is required";

    // Validate Date of Birth
    if (!formData.date_of_birth) newErrors.date_of_birth = "Date of Birth is required";

    // Validate Gender
    if (!formData.gender) newErrors.gender = "Gender is required";

    // Validate Street Address Line 1
    if (!formData.street_address_line_1)
      newErrors.street_address_line_1 = "Street Address Line 1 is required";

    // Validate City
    if (!formData.city) newErrors.city = "City is required";

    // Validate Postal Code
    if (!formData.postal_code) newErrors.postal_code = "Postal Code is required";

    // Validate Country
    if (!formData.country) newErrors.country = "Country is required";

    // Validate Mobile Number
    if (!formData.mobile_number) newErrors.mobile_number = "Mobile Number is required";

    // Validate WhatsApp Number
    if (!formData.wt_number) newErrors.wt_number = "WhatsApp Number is required";

    // Validate Email
    if (!formData.email) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
      newErrors.email = "Invalid email format";

    // Validate Land Plots (at least one must be selected)
    if (
        !formData["5_land_plots"] &&
        !formData["10_land_plots"] &&
        !formData["20_land_plots"] &&
        !formData["50_land_plots"]
    ) {
      newErrors.land_plots = "Please select at least one land plot option.";
    }

    setErrors(newErrors); // Set errors
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form
    if (!validateForm()) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Please check the form for errors.",
      });
      return; // Stop execution if validation fails
    }

    setLoading(true); // Set loading state

    try {
      // Submit form data to API
      const response = await apiClient.post('/five_year-request',
          formData
      );


      // Show success message
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Form submitted successfully!",
      });

      // Reset form
      setFormData({
        first_name: "",
        last_name: "",
        date_of_birth: "",
        gender: "",
        street_address_line_1: "",
        street_address_line_2: "",
        city: "",
        postal_code: "",
        country: "",
        mobile_number: "",
        wt_number: "",
        email: "",
        "5_land_plots": false,
        "10_land_plots": false,
        "20_land_plots": false,
        "50_land_plots": false,
        query: "",
        ip_address: "",
      });
    } catch (error) {
      console.error("Error submitting form:", error);

      // Handle API errors
      let errorMessage = "Something went wrong!";
      if (error.response) {
        errorMessage = error.response.data.message || "An error occurred while submitting the form.";
      } else if (error.request) {
        errorMessage = "No response from the server. Please try again later.";
      }

      // Show error message
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: errorMessage,
      });
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  return (
      <div className="form-page dark-gold ">
        <form onSubmit={handleSubmit}>
          <div className="form-title">
            <img src={logo} alt="" width={200} />
            <div className="details">
              <h1 className="font-second">Bhaddeka Vihari Monastery Center</h1>
              <h2 className="h4">Request Form for 5 Year Arama Pooja</h2>
            </div>
          </div>

          <p className="font-p mt-5">
            Welcome to the Bhaddheka Vihari Monastery Five year Arama Pooja Project. Kindly use the
            following form to provide your details.
          </p>

          {/* Full Name */}
          <p className="font-p mt-5">Full Name*</p>
          <div className="form-box mt-4">
            <div className="form-item">
              <input
                  type="text"
                  id="first_name"
                  name="first_name"
                  value={formData.first_name}
                  onChange={handleInputChange}
              />
              <label htmlFor="first_name">First Name</label>
              {errors.first_name && <span className="error">{errors.first_name}</span>}
            </div>
            <div className="form-item">
              <input
                  type="text"
                  id="last_name"
                  name="last_name"
                  value={formData.last_name}
                  onChange={handleInputChange}
              />
              <label htmlFor="last_name">Last Name</label>
              {errors.last_name && <span className="error">{errors.last_name}</span>}
            </div>
          </div>

          {/* Date of Birth */}
          <div className="form-box mt-4">
            <div className="form-item">
              <input
                  type="date"
                  id="date_of_birth"
                  name="date_of_birth"
                  value={formData.date_of_birth}
                  onChange={handleInputChange}
              />
              <label htmlFor="date_of_birth">Date of Birth*</label>
              {errors.date_of_birth && <span className="error">{errors.date_of_birth}</span>}
            </div>
          </div>

          {/* Gender */}
          <p className="font-p mt-5">Gender*</p>
          <div className="gender-box">
            <div>
              <input
                  type="radio"
                  id="male"
                  name="gender"
                  value="Male"
                  checked={formData.gender === "Male"}
                  onChange={handleInputChange}
              />
              <label htmlFor="male">Male</label>
            </div>
            <div>
              <input
                  type="radio"
                  id="female"
                  name="gender"
                  value="Female"
                  checked={formData.gender === "Female"}
                  onChange={handleInputChange}
              />
              <label htmlFor="female">Female</label>
            </div>
            {errors.gender && <span className="error">{errors.gender}</span>}
          </div>

          {/* Street Address Line 1 */}
          <p className="font-p mt-5">Street Address*</p>
          <div className="form-box1 mt-4">
            <div className="form-item">
              <input
                  type="text"
                  id="street_address_line_1"
                  name="street_address_line_1"
                  value={formData.street_address_line_1}
                  onChange={handleInputChange}
              />
              <label htmlFor="street_address_line_1">Street Address Line 1</label>
              {errors.street_address_line_1 && (
                  <span className="error">{errors.street_address_line_1}</span>
              )}
            </div>
          </div>

          {/* Street Address Line 2 */}
          <p className="font-p mt-5">Street Address Line 2</p>
          <div className="form-box1 mt-4">
            <div className="form-item">
              <input
                  type="text"
                  id="street_address_line_2"
                  name="street_address_line_2"
                  value={formData.street_address_line_2}
                  onChange={handleInputChange}
              />
              <label htmlFor="street_address_line_2">Street Address Line 2</label>
            </div>
          </div>

          {/* City */}
          <div className="form-box mt-5">
            <div className="form-item">
              <input
                  type="text"
                  id="city"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
              />
              <label htmlFor="city">City*</label>
              {errors.city && <span className="error">{errors.city}</span>}
            </div>
          </div>

          {/* Postal Code */}
          <div className="form-box mt-5">
            <div className="form-item">
              <input
                  type="text"
                  id="postal_code"
                  name="postal_code"
                  value={formData.postal_code}
                  onChange={handleInputChange}
              />
              <label htmlFor="postal_code">Postal Code*</label>
              {errors.postal_code && <span className="error">{errors.postal_code}</span>}
            </div>
          </div>

          {/* Country */}
          <div className="form-box mt-5">
            <div className="form-item">
              <input
                  type="text"
                  id="country"
                  name="country"
                  value={formData.country}
                  onChange={handleInputChange}
              />
              <label htmlFor="country">Country*</label>
              {errors.country && <span className="error">{errors.country}</span>}
            </div>
          </div>

          {/* Mobile Number and WhatsApp Number */}
          <div className="form-box mt-5">
            <div className="form-item">
              <input
                  type="text"
                  id="mobile_number"
                  name="mobile_number"
                  value={formData.mobile_number}
                  onChange={handleInputChange}
              />
              <label htmlFor="mobile_number">Mobile Number*</label>
              {errors.mobile_number && <span className="error">{errors.mobile_number}</span>}
            </div>
            <div className="form-item">
              <input
                  type="text"
                  id="wt_number"
                  name="wt_number"
                  value={formData.wt_number}
                  onChange={handleInputChange}
              />
              <label htmlFor="wt_number">WhatsApp Number*</label>
              {errors.wt_number && <span className="error">{errors.wt_number}</span>}
            </div>
          </div>

          {/* Email Address */}
          <div className="form-box1 mt-5">
            <div className="form-item">
              <input
                  type="text"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
              />
              <label htmlFor="email">Email Address*</label>
              {errors.email && <span className="error">{errors.email}</span>}
            </div>
          </div>

          {/* Land Plots Selection */}
          <p className="font-p mt-5">
            Please indicate which 5 year Arama Pooja project you wish to join*
          </p>
          <div className="selection mt-5">
            <div className="checkbox-box">
              <label htmlFor="5_land_plots">5 Land Plots</label>
              <input
                  type="checkbox"
                  id="5_land_plots"
                  name="5_land_plots"
                  checked={formData["5_land_plots"]}
                  onChange={handleInputChange}
              />
            </div>
            <div className="checkbox-box">
              <label htmlFor="10_land_plots">10 Land Plots</label>
              <input
                  type="checkbox"
                  id="10_land_plots"
                  name="10_land_plots"
                  checked={formData["10_land_plots"]}
                  onChange={handleInputChange}
              />
            </div>
            <div className="checkbox-box">
              <label htmlFor="20_land_plots">20 Land Plots</label>
              <input
                  type="checkbox"
                  id="20_land_plots"
                  name="20_land_plots"
                  checked={formData["20_land_plots"]}
                  onChange={handleInputChange}
              />
            </div>
            <div className="checkbox-box">
              <label htmlFor="50_land_plots">50 Land Plots</label>
              <input
                  type="checkbox"
                  id="50_land_plots"
                  name="50_land_plots"
                  checked={formData["50_land_plots"]}
                  onChange={handleInputChange}
              />
            </div>
            {errors.land_plots && <span className="error">{errors.land_plots}</span>}
          </div>

          {/* Query */}
          <p className="font-p mt-5">
            Please write any queries you may have regarding the Arama Pooja Project.
          </p>
          <div className="mt-5">
            <div className="form-item">
            <textarea
                id="query"
                name="query"
                value={formData.query}
                onChange={handleInputChange}
                rows="6"
            />
              <label htmlFor="query"></label>
            </div>
          </div>

          {/* Submit Button */}
          <button type="submit" id="submitbtn" className="mt-5" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>

          <p className="font-p mt-4">We will be in touch with you shortly.</p>
          <p className="font-p">
            Thank you for your interest in being part of our Arama Pooja community at the Bhaddheka
            Vihari Monastery.
          </p>
        </form>
      </div>
  );
};

export default FiveYearRequest;